import { OnInit } from '@angular/core';
var SpinnerComponent = /** @class */ (function () {
    function SpinnerComponent() {
        this.lineNumber = 10;
        /**
         * speed in % (default is 50)
         *
         * @memberof SpinnerComponent
         */
        this.speed = 50;
        /**
         * size in px (default is 64)
         *
         * @memberof SpinnerComponent
         */
        this.size = 'l';
        this.dark = false;
        this.lines = [];
        for (var i = 0; i < this.lineNumber; i++) {
            this.lines.push(i);
        }
    }
    SpinnerComponent.prototype.ngOnInit = function () {
    };
    Object.defineProperty(SpinnerComponent.prototype, "divClasses", {
        get: function () {
            switch (this.size) {
                case 's':
                    return 'evt-spinner evt-spinner-s';
                case 'l':
                    return 'evt-spinner evt-spinner-l';
                default:
                    throw new Error('invalid spinner size: ' + this.size);
            }
        },
        enumerable: true,
        configurable: true
    });
    SpinnerComponent.prototype.transform = function (num) {
        return "rotate(" + 360 / this.lineNumber * num + "deg)";
    };
    SpinnerComponent.prototype.delay = function (num) {
        return "-" + (1 - 1 / this.lineNumber * num) + "s";
    };
    return SpinnerComponent;
}());
export { SpinnerComponent };
